<template>
  <div class="integracion-expediente-principal" style="flex-grow: 1">
    <div class="layer-loader" v-if="redirigiendoIncode">
      <div class="layer-loader-spinner"></div>
    </div>
    <TituloSeccion :titulo="this.NombreCompletoProspecto" v-if="!redirigiendoIncode" />
    <ModalObservacion :Observacion="ObservacionArchivo" v-if="!redirigiendoIncode"></ModalObservacion>
    <div class="container contenedor-integracion-expediente">
      <stepper-integracion :pasos="this.pasos"></stepper-integracion>

      <div v-if="this.PerfilTieneAccesoAExpediente(tipoUsuario)">
        <div class="row col-lg-12" style="text-align: left" v-if="this.tipoUsuario == 3">
          <div class="col-lg-12">
            <p class="parrafo-instrucciones mt-2">
              You are in the most important stage of the process, which is why you
              must provide documentation and personal data, do not worry remember
              that all information is protected and at any time you can review our
              privacy notice.
            </p>
            <label class="parrafo-instrucciones">The following documents are required in order to perform a
              pre-authorization:</label>
            <ul class="parrafo-instrucciones">
              <li>Passport</li>
              <li>Score</li>
              <li>Credit report</li>
              <li>Bank statements</li>
              <li>Last income tax</li>
              <li>Payroll receipt</li>
            </ul>
            <label class="parrafo-instrucciones">As soon as you complete your information you will be one step away
              from making your dream come true.</label>
            <label class="parrafo-instrucciones">If you have any doubts, please consult with your ambassador.</label>
          </div>
        </div>
        <div class="row col-lg-12" style="text-align: left" v-else>
          <div class="col-lg-12">
            <p class="parrafo-instrucciones mt-2">
              Remember, this phase is of the utmost importance since the prospect
              provides us with his personal data and information. prospect
              provides us with personal data and confidential information
              confidential information, therefore, you will have to establish
              constant communication to accompany and provide certainty throughout
              the entire stage.
            </p>
          </div>
        </div>
        <div v-if="EsObligadoSolidarioOCotitular" class="row col-lg-12 seccion-integracion" style="text-align: left">
          <div class="col-lg-8 col-sm-8">
            <span>
              <strong class="titulo-seccion" style="margin-right: 10px">1. Personal Data</strong>
              <span class="ml-2" v-tooltip.right="'It is essential to review and complete your information in order to enjoy our benefits. '
                ">
                <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
              </span>
            </span>
            <p class="parrafo-instrucciones mt-2">Enter your personal data.</p>
          </div>
          <div class="col-lg-4 col-sm-4" style="text-align: center">
            <button class="btn boton-primario boton-llenar-solicitud mt-3 w-100"
              @click.prevent="LlenarDatosPersonalesFiguraAdicional()">
              {{
                this.pasos[0].completado == false
                ? "Enter personal data"
                : this.etapaProspecto > 5
                  ? "View personal data"
                  : "Edit personal data"
              }}
            </button>
            <i class="fas fa-exclamation-triangle iconos-archivo icono-observacion" v-if="observacionSolicitud != null"
              data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(observacionSolicitud.entidadId, 1)"></i>
          </div>
        </div>
        <div v-else class="row col-lg-12 seccion-integracion" style="text-align: left">
          <div class="col-lg-8 col-sm-8">
            <span>
              <strong class="titulo-seccion" style="margin-right: 10px">1. Inscription Request</strong>
              <span class="ml-2" v-tooltip.right="'Help us to complete your information, this will help us to continue with your process.'
                ">
                <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
              </span>
            </span>
            <p class="parrafo-instrucciones mt-2">
              Complete the inscription request with your personal data.
            </p>
          </div>
          <div class="col-lg-4 col-sm-4" style="text-align: center">
            <button class="btn boton-primario boton-llenar-solicitud mt-3 w-100" @click.prevent="LlenarSolicitud">
              {{
                this.pasos[0].completado == false
                ? "Complete inscription request"
                : this.etapaProspecto > 5
                  ? "View inscription request"
                  : "Edit inscription request"
              }}
            </button>
            <i class="fas fa-exclamation-triangle iconos-archivo icono-observacion" v-if="observacionSolicitud != null"
              data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(observacionSolicitud.entidadId, 1)"></i>
          </div>
        </div>
      </div>

      <div class="row col-lg-12">
        <hr class="divisor-seccion" />
      </div>


      <div v-if="this.PerfilTieneAccesoADocumentos(tipoUsuario)">
        <!--SECCIÓN DE DOCUMENTOS -->
        <hr class="divisor-seccion" />
        <div class="row col-lg-12" style="text-align: left">
          <span>
            <strong class="titulo-seccion" style="margin-right: 10px">2. Sending of documents</strong>
            <span class="ml-2" v-tooltip.right="'You will have to incorporate your documents which are a requirement to follow the process. '
              ">
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
            </span>
          </span>
          <p class="parrafo-instrucciones mt-2">
            Upload your official documents, valid formats are: pdf, png, jpg,
            office.<br />
            Maximum size: 40mb per file.
          </p>
        </div>
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento"> Upload passport</label>
        </div>
        <!--Passport-->
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(pasaporte, index) in pasaportesCargados"
          :key="'p' + pasaportesCargados.indexOf(pasaporte)">
          <input class="d-none" type="file" ref="inputPasaporte" @change="almacenarArchivoPasaporte($event, index)" />
          <div class="col-lg-10">
            <InputDocumentos @click.native="activaInputPasaporte(index)" ajusteMarginBoton="margin-top: -0.2px !important"
              :Documento="0" :NombreArchivo="pasaporte.nombreOriginal" :esExtranjero="true"
              :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="pasaporte.archivoId != null" v-on:click="descargarArchivo(pasaporte.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="pasaporte.archivoId != null" v-on:click="eliminarArchivo(pasaporte.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="pasaporte.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(pasaporte.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 seccion-integracion-ex" v-if="pasaportesCargados[pasaportesCargados.length - 1].archivoId != null
          ">
          <strong class="etiqueta-nuevo-documento" @click.prevent="MostrarInputsNuevoPasaporte()">Upload another
          </strong>
        </div>
        <!--Score-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento"> Upload score</label>
        </div>
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(score, index) in scoresCargados"
          :key="'s' + scoresCargados.indexOf(score)">
          <input class="d-none" type="file" ref="inputScore" @change="almacenarArchivoScore($event, index)" />
          <div class="col-lg-10">
            <InputDocumentos @click.native="activaInputScore(index)" ajusteMarginBoton="margin-top: 0 !important"
              :Documento="0" :NombreArchivo="score.nombreOriginal" :esExtranjero="true"
              :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="score.archivoId != null" v-on:click="descargarArchivo(score.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="score.archivoId != null" v-on:click="eliminarArchivo(score.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="score.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(score.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 seccion-integracion-ex"
          v-if="scoresCargados[scoresCargados.length - 1].archivoId != null">
          <strong class="etiqueta-nuevo-documento" @click.prevent="MostrarInputsNuevoScore()">Upload another
          </strong>
        </div>
        <!--Credit Report-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento">
            Upload credit report (The monthly payment must be visible)</label>
        </div>
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(credit, index) in creditReportsCargados"
          :key="'c' + creditReportsCargados.indexOf(credit)">
          <input class="d-none" type="file" ref="inputCreditReport"
            @change="almacenarArchivoCreditReport($event, index)" />
          <div class="col-lg-10">
            <InputDocumentos @click.native="activaInputCreditReport(index)"
              ajusteMarginBoton="margin-top: -0.2px !important" :Documento="0" :NombreArchivo="credit.nombreOriginal"
              :esExtranjero="true" :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="credit.archivoId != null" v-on:click="descargarArchivo(credit.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="credit.archivoId != null" v-on:click="eliminarArchivo(credit.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="credit.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(credit.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 seccion-integracion-ex" v-if="creditReportsCargados[creditReportsCargados.length - 1].archivoId !=
          null
          ">
          <strong class="etiqueta-nuevo-documento" @click.prevent="MostrarInputCreditReport()">Upload another
          </strong>
        </div>
        <!--Bank Statements-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento"> Upload bank statements</label>
        </div>
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(bankStatement, index) in bankStatementsCargados"
          :key="'b' + bankStatementsCargados.indexOf(bankStatement)">
          <input class="d-none" type="file" ref="inputBankStatements"
            @change="almacenarArchivoBankStatement($event, index)" />
          <div class="col-lg-10">
            <InputDocumentos @click.native="activaInputBankStatements(index)"
              ajusteMarginBoton="margin-top: 0.5px !important" :Documento="0"
              :NombreArchivo="bankStatement.nombreOriginal" :esExtranjero="true" :desactivar="desactivarInputArchivo">
            </InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="bankStatement.archivoId != null" v-on:click="descargarArchivo(bankStatement.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="bankStatement.archivoId != null" v-on:click="eliminarArchivo(bankStatement.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="bankStatement.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(bankStatement.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12" v-if="bankStatementsCargados[bankStatementsCargados.length - 1]
          .archivoId != null
          ">
          <strong class="etiqueta-nuevo-documento" @click.prevent="MostrarInputBankStatements()">Upload another
          </strong>
        </div>
        <!--Last income tax-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento"> Upload last income tax</label>
        </div>
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(income, index) in incomeTaxCargados"
          :key="'i' + incomeTaxCargados.indexOf(income)">
          <input class="d-none" type="file" ref="inputLastIncomeTax"
            @change="almacenarArchivoLastIncomeTax($event, index)" />
          <div class="col-lg-10">
            <InputDocumentos @click.native="activaInputLastIncomeTax(index)"
              ajusteMarginBoton="margin-top: -0.2px !important" :Documento="0" :NombreArchivo="income.nombreOriginal"
              :esExtranjero="true" :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="income.archivoId != null" v-on:click="descargarArchivo(income.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="income.archivoId != null" v-on:click="eliminarArchivo(income.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="income.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(income.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 seccion-integracion-ex" v-if="incomeTaxCargados[incomeTaxCargados.length - 1].archivoId != null
          ">
          <strong class="etiqueta-nuevo-documento" @click.prevent="MostrarInputLastIncomeTax()">Upload another
          </strong>
        </div>
        <!--RECIBOS DE NÓMINA / PAYROLL -->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento"> Upload payroll receipt</label>
        </div>
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(payroll, index) in payrollCargados"
          :key="'pay' + payrollCargados.indexOf(payroll)">
          <input class="d-none" type="file" ref="inputPayroll" @change="almacenarArchivoPayroll($event, index)" />
          <div class="col-lg-10">
            <InputDocumentos @click.native="activaInputPayroll(index)" ajusteMarginBoton="margin-top: -0.2px !important"
              :Documento="0" :NombreArchivo="payroll.nombreOriginal" :esExtranjero="true"
              :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="payroll.archivoId != null" v-on:click="descargarArchivo(payroll.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="payroll.archivoId != null" v-on:click="eliminarArchivo(payroll.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="payroll.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(payroll.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12" v-if="payrollCargados[payrollCargados.length - 1]
          .archivoId != null
          ">
          <strong class="etiqueta-nuevo-documento" @click.prevent="MostrarIn()">Upload another
          </strong>
        </div>
        <!--Additional-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento">
            Upload additional documents</label>
        </div>
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(adicional, index) in adicionalesCargados"
          :key="'ad' + adicionalesCargados.indexOf(adicional)">
          <input class="d-none" type="file" ref="inputAdditional" @change="almacenarArchivoAdicional($event, index)" />
          <div class="col-lg-6">
            <InputDocumentos @click.native="activaInputAdditonal(index)" ajusteMarginBoton="margin-top: -0.2px !important"
              :Documento="0" :NombreArchivo="adicional.nombreOriginal" :esExtranjero="true"
              :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-4">
            <input v-if="adicional.archivoId != null" v-model="adicional.detalle"
              @change="editarDetalle($event, adicional.archivoId)" type="text" class="form-control campo-minuscula"
              placeholder="Document details" required />
            <input v-else disabled type="text" class="form-control campo-minuscula" placeholder="Document details"
              required />
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="adicional.archivoId != null" v-on:click="descargarArchivo(adicional.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="adicional.archivoId != null" v-on:click="eliminarArchivo(adicional.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="adicional.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(adicional.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12" style="display: flex; justify-content: flex-end; margin-top: -10px" v-if="adicionalesCargados[adicionalesCargados.length - 1].archivoId !=
          null
          ">
          <strong style="width: auto" class="etiqueta-nuevo-documento" @click.prevent="MostrarInputAdditional()">Upload
            another
          </strong>
        </div>
        <hr class="divisor-seccion" />
      </div>

      <div v-if="this.PerfilTieneAccesoABuro(tipoUsuario)">
        <div v-if="tipoUsuario == 3" class="row col-lg-12 seccion-integracion-d" style="text-align: left">
          <div class="col-lg-8">
            <strong class="titulo-seccion">3. Digital Onboarding</strong>
            <p class="parrafo-instrucciones mt-2">
              Complete the process, take into account that you must carry out the
              process in a mobile device.
            </p>
          </div>
          <div class="col-lg-4" style="text-align: center">
            <button v-if="pasos[0].completado == true &&
              pasos[1].completado == true &&
              pasos[2].completado == false
              " class="btn boton-primario boton-llenar-solicitud mt-3 w-100" @click.prevent="DigitalOnboarding()">
              Onboarding
            </button>
            <button v-else-if="pasos[2].completado == false" class="btn boton-primario boton-llenar-solicitud mt-3 w-100"
              disabled>
              Onboarding
            </button>
            <span v-if="pasos[2].completado == true">
              <i class="fas fa-lock ml-2" style="color: #00917c; font-size: 20px"></i>
              <label style="font-family: 'Poppins'; color: #00917c; margin-left: 15px">
                Completed</label>
            </span>
          </div>
        </div>
      </div>

      <div class="row col-lg-12" v-if="this.PerfilTieneAccesoAExpediente(tipoUsuario)">
        <div class="col-lg-8"></div>
        <div
          v-if="tipoUsuario == 3 || tipoUsuario == 4 || tipoUsuario == 5 || tipoUsuario == 6 || tipoUsuario == 8 || tipoUsuario == 10"
          class="col-lg-4">
          <button disabled v-if="integrandoExpediente" class="
              btn
              boton-primario boton-llenar-solicitud boton-finalizar-integracion
              w-100
            ">
            <v-progress-circular indeterminate size="30" color="primary"></v-progress-circular>
          </button>
          <button v-else class="
              btn
              boton-primario boton-llenar-solicitud boton-finalizar-integracion
              w-100
            " v-on:click="terminarIntegracionExpediente">
            Finish
          </button>
        </div>
      </div>
    </div>
    <!-- Componente de qr -->
    <QrCodeDialog :modalActivo="modalVisibleQr" @modalClosed="updateModalState"></QrCodeDialog>
  </div>
</template>

<script>
//Plugins, mixins y servicios.
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
import servicios from "../../../servicios/service.js";
import { getSession } from "@/Aplicaciones/Masters/apiConnection/api_client";
import axios from "axios";
import ModalObservacion from "../components/ModalObservacion.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import InputDocumentos from "../components/InputDocumentos.vue";
import StepperIntegracion from "../components/StepperIntegracion.vue";
import QrCodeDialog from "@/Aplicaciones/Masters/Areas/Prospecto/components/QrCodeDilaog.vue"


const rutaConsultarObservacionArchivo =
  "/api/Master/PreAutorizacion/ConsultarObservacionArchivo";
const rutaCargarDatosPassport =
  "/api/Master/IntegracionExpediente/CargarDatosPasaporteProspecto";
const rutaCrearArchivoPassport =
  "/api/Master/IntegracionExpediente/CrearArchivoPasaporte";
const rutaCargarDatosScore =
  "/api/Master/IntegracionExpediente/CargarDatosScoreProspecto";
const rutaCrearArchivoScore =
  "/api/Master/IntegracionExpediente/CrearArchivoScoreProspecto";
const rutaCargarDatosCreditReport =
  "/api/Master/IntegracionExpediente/CargarDatosCreditReportProspecto";
const rutaCrearArchivoCreditReport =
  "/api/Master/IntegracionExpediente/CrearArchivoCreditReportProspecto";
const rutaCargarDatosBankStatement =
  "/api/Master/IntegracionExpediente/CargarDatosBankStatementProspecto";
const rutaCrearArchivoBankStatement =
  "/api/Master/IntegracionExpediente/CrearArchivoBankStatementProspecto";
const rutaCargarDatosIncomeTax =
  "/api/Master/IntegracionExpediente/CargarDatosIncomeTaxProspecto";
const rutaCrearArchivoIncomeTax =
  "/api/Master/IntegracionExpediente/CrearArchivoIncomeTaxProspecto";
const rutaCargarDatosAdditional =
  "/api/Master/IntegracionExpediente/CargarDatosAdditionalProspecto";
const rutaCargarDatosPayroll =
  "/api/Master/IntegracionExpediente/CargarDatosPayrollProspecto";
const rutaCrearArchivoAdditional =
  "/api/Master/IntegracionExpediente/CrearArchivoAdditionalProspecto";
const rutaCrearArchivoPayroll =
  "/api/Master/IntegracionExpediente/CrearArchivoPayrollProspecto";
const rutaTerminarIntegracionExpediente =
  "/api/Master/IntegracionExpediente/TerminarIntegracionExpediente";
const rutaDescargarArchivo = "/api/Master/Archivo/DescargarArchivo";
const rutaEliminarArchivo = "/api/Master/Archivo/EliminarArchivo";
const rutaActualizarArchivo = "/api/Master/Archivo/ActualizarArchivo";
const rutaActualizarDetalle = "/api/Master/IntegracionExpediente/EditarDetalle";
const rutaProspectoExpedienteCompleto =
  "/api/Master/IntegracionExpediente/ProspectoTieneCompletoExpediente";
const rutaProspectoSolicitudCompleta =
  "/api/Master/IntegracionExpediente/ProspectoTieneCompletaSolicitud";


export default {
  name: "IntegracionExpedienteExtranjero",
  mixins: [mixinSolicitudInscripcion],
  components: {
    ModalObservacion,
    TituloSeccion,
    InputDocumentos,
    StepperIntegracion,
    QrCodeDialog
  },
  async mounted() {
    servicios.OnboardingOnProgress(false);
    //this.tipoPersona = this.$store.getters.tipoPersona;
    this.respuestaIncode = this.$route.params["respuestaIncode"];
    if (this.respuestaIncode == true) {
      this.$fire({
        title: "Bureau authorization approved",
        html:
          "<br>Authentication of your identity has been successful.<br>" +
          "Select the finish button to conclude the file integration process.<br>",
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: "Accept",
      });
    }

    this.redirigiendoIncode = false;
    document.getElementsByClassName(
      "principal-menu-navegacion"
    )[0].style.display = "block";

    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = await this.ObtenerTipoPersona(this.ProspectoId);
    let datos = (await this.ObtenerDatosProspecto(this.ProspectoId)).data.data;

    this.NombreCompletoProspecto = "FILE INTEGRATION: " + datos.nombres + " " + datos.apellidoMaterno + " " + datos.apellidoPaterno;

    this.etapaProspecto = datos.etapaId;
    await this.ProspectoTieneCompletoExpediente();
    await this.ProspectoTieneCompletaSolicitud();
    await this.ConsultarSolicitudes(this.ProspectoId, false);
    await this.SolicitudTieneObservacion(this.ProspectoId, 1);
    await this.ObtenerSesionIncode();
    if ((this.tipoUsuario == 3 && this.etapaProspecto > 4) ||
      ((this.tipoUsuario == 5 ||
        this.tipoUsuario == 6 ||
        this.tipoUsuario == 8 ||
        this.tipoUsuario == 9 ||
        this.tipoUsuario == 10) &&
        this.etapaProspecto > 4)
    ) {
      this.desactivarInputArchivo = true;
      this.pasos[2].completado = true;
      this.desactivaDescargarArchivo = true;
    }
    if (servicios.PerfilTieneAccesoADocumentos(this.tipoUsuario)) {
      this.refrescarFormulario();
    }
    const preonboarding = sessionStorage.getItem('preonboarding') == 'true' ? true : false 
    if(preonboarding){
      await this.DigitalOnboarding()
    }
  },
  data() {
    return {
      integrandoExpediente: false,
      pasos: [
        {
          nombre: this.EsObligadoSolidarioOCotitular
            ? "Personal Data"
            : "Inscription Request",
          completado: false,
        },
        {
          nombre: "Sending of documents",
          completado: false,
        },
        {
          nombre: "Digital Onboarding",
          completado: false,
        },
      ],
      NombreCompletoProspecto: "",
      tipoUsuario: null,
      tipoPersona: 0,
      ProspectoId: null,
      SolicitudId: 0,
      ArchivoPassport: null,
      ArchivosScore: [],
      ArchivoScore: null,
      ArchivosCreditReport: [],
      ArchivoCreditReport: null,
      ArchivosBankStatements: [],
      ArchivoBankStatement: null,
      ArchivosIncomeTax: [],
      ArchivoIncomeTax: null,
      ArchivosAdditional: [],
      ArchivoAdditional: null,
      ObservacionArchivo: null,
      MostrarInputNuevoScore: false,
      MostrarInputNuevoCreditReport: false,
      MostrarInputNuevoBankStatements: false,
      MostrarInputNuevoLastIncomeTax: false,
      MostrarInputNuevoAdditional: false,
      MostrarInputNuevoPayroll: false,
      nombreNuevoArchivoPasaporte: null,
      nombreNuevoArchivoScore: null,
      nombreNuevoArchivoCreditReport: null,
      nombreNuevoArchivoBankStatements: null,
      nombreNuevoArchivoLastIncomeTax: null,
      nombreNuevoArchivoAdditional: null,
      observacionSolicitud: null,
      redirigiendoIncode: false,
      respuestaIncode: false,
      SesionCompletada: false,
      etapaProspecto: null,
      desactivaDescargarArchivo: false,
      desactivarInputArchivo: false,
      //Arreglos iniciales para guardado de archivos
      pasaportesCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      scoresCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      creditReportsCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      bankStatementsCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      incomeTaxCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      adicionalesCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      payrollCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      isMobile: /Mobi/i.test(navigator.userAgent),
      modalVisibleQr: false,
    };
  },
  computed: {
    EsObligadoSolidarioOCotitular() {
      var tipo = this.tipoPersona;
      if (tipo == 4 || tipo == 5 || tipo == 6 || tipo == 7) return true;
      return false;
    },
    PasosStepper() {
      return [
        {
          nombre: this.EsObligadoSolidarioOCotitular
            ? "Personal Data"
            : "Inscription Request",
          completado: false,
        },
        {
          nombre: "Sending Of Documents",
          completado: false,
        },
        {
          nombre: "Digital Onboarding",
          completado: false,
        },
      ];
    },
  },
  methods: {
    activaInput(documento) {
      if (documento != null) console.log(this.etapaProspecto);
      if (this.etapaProspecto < 5) this.$refs["inputIdentificacion"].click();
    },
    activaInputComprobante(index, documento) {
      if (documento != null) console.log(this.etapaProspecto);
      if (this.etapaProspecto < 5) this.$refs.inputComprobante[index].click();
    },
    activaInputNuevoComprobante() {
      this.$refs["inputNuevoComprobante"].click();
    },
    activaInputBuro(documento) {
      if (documento != null)
        if (this.etapaProspecto < 5) this.$refs["inputBuro"].click();
    },
    PerfilTieneAccesoAExpediente(usuario) {
      return servicios.PerfilTieneAccesoAExpediente(usuario);
    },
    PerfilTieneAccesoADocumentos(usuario) {
      return servicios.PerfilTieneAccesoADocumentos(usuario);
    },
    PerfilTieneAccesoABuro(usuario) {
      return servicios.PerfilTieneAccesoABuro(usuario);
    },
    ProspectoTieneCompletaSolicitud() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaProspectoSolicitudCompleta, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.pasos[0].completado = resp.data.data;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ProspectoTieneCompletoExpediente() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaProspectoExpedienteCompleto, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.pasos[1].completado = resp.data.data;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    //Pasaporte
    cargarDocumentosPassport() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };

      axios
        .get(rutaCargarDatosPassport, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloPasaportes = resp.data.data;
            if (arregloPasaportes.length > 0) {
              this.pasaportesCargados = [];
              for (var item of arregloPasaportes) {
                let pasaporte = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.pasaportesCargados.push(pasaporte);
              }
              this.$forceUpdate();
            } else {
              this.pasaportesCargados = [];
              this.pasaportesCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    almacenarArchivoPasaporte(event, index) {
      this.pasaportesCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoPasaporte(index);
    },
    activaInputPasaporte(index) {
      this.$refs.inputPasaporte[index].click();
    },
    subirArchivoPasaporte(index) {
      if (this.ProspectoId != null) {
        if (this.pasaportesCargados[index].archivoId != null) {
          if (this.pasaportesCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              "You must select a file.",
              true,
              true
            );
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.pasaportesCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file format you have selected is invalid.",
            true,
            true
          );
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.pasaportesCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file you have selected is too large.",
            true,
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.pasaportesCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.pasaportesCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.pasaportesCargados[index].archivo
        );
        axios
          .post(rutaCrearArchivoPassport, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.cargarDocumentosPassport();
              this.ProspectoTieneCompletoExpediente();
              this.AlertaEmbajadores("File was successfully saved.", true, true);
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    MostrarInputsNuevoPasaporte() {
      this.pasaportesCargados.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Score
    cargarDocumentosScore() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };

      axios
        .get(rutaCargarDatosScore, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloScores = resp.data.data;
            if (arregloScores.length > 0) {
              this.scoresCargados = [];
              for (var item of arregloScores) {
                let score = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.scoresCargados.push(score);
              }
              this.$forceUpdate();
            } else {
              this.scoresCargados = [];
              this.scoresCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    almacenarArchivoScore(event, index) {
      this.scoresCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoScore(index);
    },
    activaInputScore(index) {
      this.$refs.inputScore[index].click();
    },
    subirArchivoScore(index) {
      if (this.ProspectoId != null) {
        if (this.scoresCargados[index].archivoId != null) {
          if (this.scoresCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              "You must select a file.",
              true,
              true
            );
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.scoresCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file format you have selected is invalid.",
            true,
            true
          );
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.scoresCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file you have selected is too large.",
            true,
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.scoresCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.scoresCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.scoresCargados[index].archivo);

        axios
          .post(rutaCrearArchivoScore, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.cargarDocumentosScore();
              this.ProspectoTieneCompletoExpediente();
              this.AlertaEmbajadores("File was successfully saved.", true, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    MostrarInputsNuevoScore() {
      this.scoresCargados.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Credit Report
    cargarDocumentosCreditReport() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCargarDatosCreditReport, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloCreditReports = resp.data.data;
            if (arregloCreditReports.length > 0) {
              this.creditReportsCargados = [];
              for (var item of arregloCreditReports) {
                let creditReport = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.creditReportsCargados.push(creditReport);
              }
              this.$forceUpdate();
            } else {
              this.creditReportsCargados = [];
              this.creditReportsCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    almacenarArchivoCreditReport(event, index) {
      this.creditReportsCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoCreditReport(index);
    },
    activaInputCreditReport(index) {
      this.$refs.inputCreditReport[index].click();
    },
    subirArchivoCreditReport(index) {
      if (this.ProspectoId != null) {
        if (this.creditReportsCargados[index].archivoId != null) {
          if (this.creditReportsCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              "You must select a file.",
              true,
              true
            );
            return;
          }
        }
        if (
          !servicios.validarFormatoArchivoValido(
            this.creditReportsCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file format you have selected is invalid.",
            true,
            true
          );
          return;
        }
        if (
          !servicios.validarTamanioArchivoValido(
            this.creditReportsCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file you have selected is too large.",
            true,
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.creditReportsCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.creditReportsCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.creditReportsCargados[index].archivo
        );

        axios
          .post(rutaCrearArchivoCreditReport, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.cargarDocumentosCreditReport();
              this.ProspectoTieneCompletoExpediente();
              this.AlertaEmbajadores("File was successfully saved.", true, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    MostrarInputCreditReport() {
      this.creditReportsCargados.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Bank statements
    cargarDocumentosBankStatement() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };

      axios
        .get(rutaCargarDatosBankStatement, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloBankStatements = resp.data.data;
            if (arregloBankStatements.length > 0) {
              this.bankStatementsCargados = [];
              for (var item of arregloBankStatements) {
                let bankStatement = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.bankStatementsCargados.push(bankStatement);
              }
              this.$forceUpdate();
            } else {
              this.bankStatementsCargados = [];
              this.bankStatementsCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    almacenarArchivoBankStatement(event, index) {
      this.bankStatementsCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoBankStatement(index);
    },
    activaInputBankStatements(index) {
      this.$refs.inputBankStatements[index].click();
    },
    subirArchivoBankStatement(index) {
      if (this.ProspectoId != null) {
        if (this.bankStatementsCargados[index].archivoId != null) {
          if (this.bankStatementsCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              "You must select a file.",
              true,
              true
            );
            return;
          }
        }
        if (
          !servicios.validarFormatoArchivoValido(
            this.bankStatementsCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? "The file format you have selected is invalid."
              : "El formato del archivo que seleccionaste no es válido.",
            true,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false
          );
          return;
        }
        if (
          !servicios.validarTamanioArchivoValido(
            this.bankStatementsCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file you have selected is too large.",
            true,
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.bankStatementsCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.bankStatementsCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.bankStatementsCargados[index].archivo
        );

        axios
          .post(rutaCrearArchivoBankStatement, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.cargarDocumentosBankStatement();
              this.ProspectoTieneCompletoExpediente();
              this.AlertaEmbajadores("File was successfully saved.", true, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    MostrarInputBankStatements() {
      this.bankStatementsCargados.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Last income tax
    cargarDocumentosIncomeTax() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };

      axios
        .get(rutaCargarDatosIncomeTax, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloIncomeTax = resp.data.data;
            if (arregloIncomeTax.length > 0) {
              this.incomeTaxCargados = [];
              for (var item of arregloIncomeTax) {
                let income = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.incomeTaxCargados.push(income);
              }
              this.$forceUpdate();
            } else {
              this.incomeTaxCargados = [];
              this.incomeTaxCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    subirArchivoIncomeTax(index) {
      if (this.ProspectoId != null) {
        if (this.incomeTaxCargados[index].archivoId != null) {
          if (this.incomeTaxCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              "You must select a file.",
              true,
              true
            );
            return;
          }
        }
        if (
          !servicios.validarFormatoArchivoValido(
            this.incomeTaxCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file format you have selected is invalid.",
            true,
            true
          );
          return;
        }
        if (
          !servicios.validarTamanioArchivoValido(
            this.incomeTaxCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file you have selected is too large.",
            true,
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.incomeTaxCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.incomeTaxCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.incomeTaxCargados[index].archivo);

        axios
          .post(rutaCrearArchivoIncomeTax, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.cargarDocumentosIncomeTax();
              this.ProspectoTieneCompletoExpediente();
              this.AlertaEmbajadores("File was successfully saved.", true, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoLastIncomeTax(event, index) {
      this.incomeTaxCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoIncomeTax(index);
    },
    activaInputLastIncomeTax(index) {
      this.$refs.inputLastIncomeTax[index].click();
    },
    MostrarInputLastIncomeTax() {
      this.incomeTaxCargados.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Adicionales
    cargarDocumentosAdditional() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };

      axios
        .get(rutaCargarDatosAdditional, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloAdicionales = resp.data.data;
            if (arregloAdicionales.length > 0) {
              this.adicionalesCargados = [];
              for (var item of arregloAdicionales) {
                let adicional = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  detalle: item.detalle,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.adicionalesCargados.push(adicional);
              }
              this.$forceUpdate();
            } else {
              this.adicionalesCargados = [];
              this.adicionalesCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    subirArchivoAdditional(index) {
      if (this.ProspectoId != null) {
        if (this.adicionalesCargados[index].archivoId != null) {
          if (this.adicionalesCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              "You must select a file.",
              true,
              true
            );
            return;
          }
        }
        if (
          !servicios.validarFormatoArchivoValido(
            this.adicionalesCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file format you have selected is invalid.",
            true,
            true
          );
          return;
        }
        if (
          !servicios.validarTamanioArchivoValido(
            this.adicionalesCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file you have selected is too large.",
            true,
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.adicionalesCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.adicionalesCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.adicionalesCargados[index].archivo
        );

        axios
          .post(rutaCrearArchivoAdditional, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.cargarDocumentosAdditional();
              this.ProspectoTieneCompletoExpediente();
              this.AlertaEmbajadores("File was successfully saved.", true, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoAdicional(event, index) {
      this.adicionalesCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoAdditional(index);
    },
    editarDetalle(event, archivoId) {
      axios
        .post(
          rutaActualizarDetalle +
          "?detalle=" +
          event.target.value +
          "&archivoId=" +
          archivoId
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(
              "Document detail was updated successfully",
              true,
              true
            );
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    activaInputAdditonal(index) {
      this.$refs.inputAdditional[index].click();
    },
    MostrarInputAdditional() {
      this.adicionalesCargados.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //PAYROLL
    almacenarArchivoPayroll(event, index) {
      this.payrollCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoPayroll(index);
    },
    activaInputPayroll(index) {
      this.$refs.inputPayroll[index].click();
    },
    subirArchivoPayroll(index) {
      if (this.ProspectoId != null) {
        if (this.payrollCargados[index].archivoId != null) {
          if (this.payrollCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              "You must select a file.",
              true,
              true
            );
            return;
          }
        }
        if (
          !servicios.validarFormatoArchivoValido(
            this.payrollCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file format you have selected is invalid.",
            true,
            true
          );
          return;
        }
        if (
          !servicios.validarTamanioArchivoValido(
            this.payrollCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            "The file you have selected is too large.",
            true,
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.payrollCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.payrollCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.payrollCargados[index].archivo);

        axios
          .post(rutaCrearArchivoPayroll, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.cargarDocumentosPayroll();
              this.ProspectoTieneCompletoExpediente();
              this.AlertaEmbajadores("File was successfully saved.", true, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    MostrarInputPayroll() {
      this.payrollCargados.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    cargarDocumentosPayroll() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCargarDatosPayroll, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloPayrolls = resp.data.data;
            if (arregloPayrolls.length > 0) {
              this.payrollCargados = [];
              for (var item of arregloPayrolls) {
                let payroll = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  detalle: item.detalle,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.payrollCargados.push(payroll);
              }
              this.$forceUpdate();
            } else {
              this.payrollCargados = [];
              this.payrollCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    //ALERTA PERSONALIZADA
    AlertaEmbajadores(mensaje, bold) {
      if (bold) {
        this.$fire({
          title: mensaje,
          confirmButtonText: "Ok",
        });
      } else {
        this.$fire({
          text: mensaje,
          confirmButtonText: "Ok",
        });
      }
    },
    VerObservacion(archivoId, tipoEntidad) {
      const archivo = {
        params: {
          entidadId: archivoId,
          tipoEntidad: tipoEntidad,
        },
      };
      axios
        .get(rutaConsultarObservacionArchivo, archivo)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ObservacionArchivo = resp.data.data.resultado;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    LlenarDatosPersonalesFiguraAdicional() {
      if (this.etapaProspecto == 5) {
        if (this.tipoUsuario != 1) {
          switch (this.tipoPersona) {
            case 4:
            case 6:
              this.$router.push({ name: "DatosPersonalesFiguraAdicional" });
              break;
            case 5:
            case 7:
              this.$router.push({ name: "DatosPersonalesFiguraAdicionalex" });
              break;
          }
        }
      } else {
        switch (this.tipoPersona) {
          case 4:
          case 6:
            this.$router.push({ name: "DatosPersonalesFiguraAdicional" });
            break;
          case 5:
          case 7:
            this.$router.push({ name: "DatosPersonalesFiguraAdicionalex" });
            break;
        }
      }
    },
    LlenarSolicitud() {
      this.$store.commit("setSolicitudExtranjera", this.SolicitudId);
      if (this.$route.params.vieneDeAdministracion == undefined)
        this.$router.push("FormularioSolicitudInscripcionex");
      else
        this.$router.push({
          name: "FormularioSolicitudInscripcionex",
          params: { vieneDeAdministracion: true },
        });
    },
    refrescarFormulario() {
      this.cargarDocumentosPassport();
      this.cargarDocumentosScore();
      this.cargarDocumentosCreditReport();
      this.cargarDocumentosBankStatement();
      this.cargarDocumentosIncomeTax();
      this.cargarDocumentosAdditional();
      this.cargarDocumentosPayroll();
    },
    descargarArchivo(archivoId) {
      window.location.href = rutaDescargarArchivo + "?archivoId=" + archivoId;
    },
    eliminarArchivo(archivoId) {
      this.$fire({
        title: "Delete File",
        html:
          "<br>You are about to delete this file.<br>" +
          "Do you want to continue?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value) {
          var paqueteDeDatos = new FormData();
          paqueteDeDatos.append("archivoId", archivoId);

          axios
            .post(rutaEliminarArchivo, paqueteDeDatos)
            .then((resp) => {
              if (resp.data.estado === 0) {
                this.ProspectoTieneCompletoExpediente();
                this.refrescarFormulario();
                this.AlertaEmbajadores("File was successfully deleted.", true, true);
              }
            })
            .catch((e) => {
              this.ManejarExcepcion(e);
            });
        }
      });
    },
    actualizarArchivo(event, archivoId) {
      var paqueteDeDatos = new FormData();
      paqueteDeDatos.append("archivoId", archivoId);
      paqueteDeDatos.append("archivo", event.target.files[0]);

      axios
        .post(rutaActualizarArchivo, paqueteDeDatos)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.refrescarFormulario();
            this.AlertaEmbajadores("File was successfully saved.", true, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async terminarIntegracionExpediente() {
      this.integrandoExpediente = true;
      if (this.ProspectoId != null) {
        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("AplicacionId", 0);
        axios
          .post(rutaTerminarIntegracionExpediente, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              if (this.tipoUsuario == 3) {
                this.integrandoExpediente = false;
                this.$router.push({
                  name: "SeguimientoProspecto",
                });
              } else {
                this.AlertaEmbajadores(
                  "The file has been sent for pre-authorization.",
                  true, true
                );
                this.$router.push({
                  name: "AdministracionDeProspectos",
                });
              }
            } else if (resp.data.estado === 1) {
              this.integrandoExpediente = false;
              this.AlertaEmbajadores(resp.data.mensaje, true, true);
            }
          })
          .catch((e) => {
            this.integrandoExpediente = false;
            this.ManejarExcepcion(e);
          });
      }
    },
    EsDispositivoMovil() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? true
        : false;
    },
    DigitalOnboarding() {
      this.$store.commit('setGoToSinOnboarding', {to:'IntegracionExpedienteExtranjero'})
      this.$router.push({ name: "InformacionAutenticacionIdentidad" });
      if (this.pasos[0].completado && this.pasos[1].completado) {
        if (this.isMobile) {
          this.$router.push({ name: "WelcomeOnBoarding" });
        } else {
          this.$router.push({ name: "InformacionAutenticacionIdentidad" });
        }
      } else {
        this.AlertaEmbajadores(
          "Please complete the previous steps (1-Inscription Request and 2-Sending of documents) to continue.",
          true, true
        );
      }
    },
    async ObtenerSesionIncode() {
      const session = await getSession(this.ProspectoId);
      if (session != null) {
        if (session.finishStatus == 'COMPLETE') {
          this.SesionCompletada = true;
          this.pasos[2].completado = true;
        } else {
          this.SesionCompletada = false;
          this.pasos[2].completado = false;
        }
      } else {
        this.SesionCompletada = false;
        this.pasos[2].completado = false;
      }
    },
    async ConsultaSesionIncode() {
      const session = await getSession(this.ProspectoId);
      return session;
    },
    toggleModalQr() {
      this.modalVisibleQr = true
    },
    updateModalState() {
      this.modalVisibleQr = false; // Actualiza la variable cuando se emite el evento
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.btn-terminar {
  background-color: #1e2120;
  color: white;
  -webkit-box-shadow: 0px 8px 20px -6px rgba(85, 85, 85, 0.91);
  box-shadow: 0px 8px 20px -6px rgba(85, 85, 85, 0.91);
}
</style>
